//! Auto-generated workflow types
//! Do not edit this file manually - run 'npm run generate:workflow-types' to regenerate

/**
 * Union type of all available workflow function names
 */
export type WorkflowName =
  | "approveBookingKit"
  | "createBookingKit"
  | "notifyBaOnServicePrefExp"
  | "pollWorkrequestMailbox"
  | "processIncomingWorkrequest"
  | "processMedloWorkrequest"
  | "processSubmittedTimereport"
  | "publishSelfInvoicingContract"
  | "publishSubcontractorInvoice"
  | "publishWccConsultantContract"
  | "reactivatePausedQualityItem"
  | "scanExpiringServicePref"
  | "publishPayFormRecordsToFortnox"
  | "publishSickPayFormToFortnox"
  | "sendTimereportApprovedNotification"
  | "sendTimereportToCustomer";

/**
 * Record of workflow names to their string literals for type safety
 */
export const WorkflowNames = {
  approveBookingKit: "approveBookingKit",
  createBookingKit: "createBookingKit",
  notifyBaOnServicePrefExp: "notifyBaOnServicePrefExp",
  pollWorkrequestMailbox: "pollWorkrequestMailbox",
  processIncomingWorkrequest: "processIncomingWorkrequest",
  processMedloWorkrequest: "processMedloWorkrequest",
  processSubmittedTimereport: "processSubmittedTimereport",
  publishSelfInvoicingContract: "publishSelfInvoicingContract",
  publishSubcontractorInvoice: "publishSubcontractorInvoice",
  publishWccConsultantContract: "publishWccConsultantContract",
  reactivatePausedQualityItem: "reactivatePausedQualityItem",
  scanExpiringServicePref: "scanExpiringServicePref",
  publishPayFormRecordsToFortnox: "publishPayFormRecordsToFortnox",
  publishSickPayFormToFortnox: "publishSickPayFormToFortnox",
  sendTimereportApprovedNotification: "sendTimereportApprovedNotification",
  sendTimereportToCustomer: "sendTimereportToCustomer"
} as const;

/**
 * Array of all workflow names
 */
export const ALL_WORKFLOW_NAMES: readonly WorkflowName[] = [
  "approveBookingKit",
  "createBookingKit",
  "notifyBaOnServicePrefExp",
  "pollWorkrequestMailbox",
  "processIncomingWorkrequest",
  "processMedloWorkrequest",
  "processSubmittedTimereport",
  "publishSelfInvoicingContract",
  "publishSubcontractorInvoice",
  "publishWccConsultantContract",
  "reactivatePausedQualityItem",
  "scanExpiringServicePref",
  "publishPayFormRecordsToFortnox",
  "publishSickPayFormToFortnox",
  "sendTimereportApprovedNotification",
  "sendTimereportToCustomer"
] as const;

/**
 * Type guard to check if a string is a valid workflow name
 */
export function isValidWorkflowName(name: string): name is WorkflowName {
  return ALL_WORKFLOW_NAMES.includes(name as WorkflowName);
}

/**
 * Workflow information for debugging and documentation
 */
export const WORKFLOW_INFO = {
  approveBookingKit: {
    name: "approveBookingKit",
    filePath: "booking-kit/approve-booking-kit/approve-booking-kit.ts",
    exportName: "approveBookingKit"
  },
  createBookingKit: {
    name: "createBookingKit",
    filePath: "booking-kit/create-booking-kit/create-booking-kit.ts",
    exportName: "createBookingKit"
  },
  notifyBaOnServicePrefExp: {
    name: "notifyBaOnServicePrefExp",
    filePath: "notify-ba-on-service-pref-exp/notify-ba-on-service-pref-exp.ts",
    exportName: "notifyBaOnServicePrefExp"
  },
  scanExpiringServicePref: {
    name: "scanExpiringServicePref",
    filePath: "notify-ba-on-service-pref-exp/scan-expiring-service-pref.ts",
    exportName: "scanExpiringServicePref"
  },
  publishSelfInvoicingContract: {
    name: "publishSelfInvoicingContract",
    filePath: "publish-consultant-contracts/publish-self-invoicing-contract.ts",
    exportName: "publishSelfInvoicingContract"
  },
  publishWccConsultantContract: {
    name: "publishWccConsultantContract",
    filePath: "publish-consultant-contracts/publish-wcc-consultant-contract.ts",
    exportName: "publishWccConsultantContract"
  },
  publishSubcontractorInvoice: {
    name: "publishSubcontractorInvoice",
    filePath: "publish-subcontractor-invoice/publish-subcontractor-invoice.ts",
    exportName: "publishSubcontractorInvoice"
  },
  pollWorkrequestMailbox: {
    name: "pollWorkrequestMailbox",
    filePath: "poll-workrequest-mailbox/poll-workrequest-mailbox.ts",
    exportName: "pollWorkrequestMailbox"
  },
  processIncomingWorkrequest: {
    name: "processIncomingWorkrequest",
    filePath: "process-incoming-workrequest/process-incoming-workrequest.ts",
    exportName: "processIncomingWorkrequest"
  },
  processMedloWorkrequest: {
    name: "processMedloWorkrequest",
    filePath: "process-medlo-workrequest/process-medlo-workrequest.ts",
    exportName: "processMedloWorkrequest"
  },
  publishPayFormRecordsToFortnox: {
    name: "publishPayFormRecordsToFortnox",
    filePath: "publish-pay-form-records-to-fortnox/publish-pay-form-records-to-fortnox.ts",
    exportName: "publishPayFormRecordsToFortnox"
  },
  publishSickPayFormToFortnox: {
    name: "publishSickPayFormToFortnox",
    filePath: "publish-sick-pay-form-to-fortnox/publish-sick-pay-form-to-fortnox.ts",
    exportName: "publishSickPayFormToFortnox"
  },
  sendTimereportApprovedNotification: {
    name: "sendTimereportApprovedNotification",
    filePath: "send-timereport-approved-notification/send-timereport-approved-notification.ts",
    exportName: "sendTimereportApprovedNotification"
  },
  sendTimereportToCustomer: {
    name: "sendTimereportToCustomer",
    filePath: "send-timereport-to-customer/send-timereport-to-customer.ts",
    exportName: "sendTimereportToCustomer"
  },
  processSubmittedTimereport: {
    name: "processSubmittedTimereport",
    filePath: "process-submitted-timereport/process-submitted-timereport.ts",
    exportName: "processSubmittedTimereport"
  },
  reactivatePausedQualityItem: {
    name: "reactivatePausedQualityItem",
    filePath: "reactivate-paused-quality-item/reactivate-paused-quality-item.ts",
    exportName: "reactivatePausedQualityItem"
  }
} as const;
